import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import GoogleSignInButton from "@/components/GoogleSignInButton";
import { getBrand } from "@/lib/brand";

const LOGO = "/angel-logo.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const brand = getBrand();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) return toast.error(r.error);
    toast.success("¡Bienvenido!");
    const dest = r.user.role === "admin" ? "/admin" : r.user.role === "afiliado" ? "/socios" : "/cuenta";
    navigate(dest);
  };

  return (
    <div className="auth-page">
      <Helmet>
        <title>{`Iniciar sesión — ${brand.name}`}</title>
        <meta name="description" content={`Accede a tu portal de Membresía ${brand.name}. Gestiona tu membresía, beneficiarios y solicita servicios 24/7.`} />
        <meta property="og:title" content={`Iniciar sesión — ${brand.name}`} />
        <meta property="og:description" content="Accede a tu portal de membresía y gestiona los servicios 24/7 de tu familia." />
        <link rel="canonical" href={brand.seo.canonical + "cuenta/login"} />
      </Helmet>
      <div className="auth-card" data-testid="login-card">
        <Link to="/"><img src={LOGO} alt={`Membresía ${brand.name}`} className="auth-logo" /></Link>
        <h1 className="auth-title">Inicia sesión en tu cuenta</h1>
        <p className="auth-sub">Accede a tu portal de membresía para gestionar la membresía 24/7 de tu familia en México.</p>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading} data-testid="login-submit">
            {loading ? "Entrando..." : "Iniciar sesión"}
          </button>
        </form>
        <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "18px 0 14px", color: "#9ca3af", fontSize: 12 }}>
          <span style={{ flex: 1, height: 1, background: "#e7eaf2" }} /> o <span style={{ flex: 1, height: 1, background: "#e7eaf2" }} />
        </div>
        <GoogleSignInButton />
        <p className="auth-foot">
          ¿No tienes cuenta? <Link to="/cuenta/registro" data-testid="go-registro">Regístrate</Link>
        </p>
        <div className="auth-seo-block" style={{ textAlign: "left", marginTop: 28, paddingTop: 22, borderTop: "1px solid #e7eaf2" }}>
          <h2 style={{ fontSize: 16, color: "#163680", margin: "0 0 10px", fontWeight: 700, textAlign: "left" }}>¿Qué puedes hacer desde tu portal?</h2>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li style={{ fontSize: 13, color: "#4b5563", padding: "5px 0 5px 22px", position: "relative", lineHeight: 1.5, textAlign: "left" }}><span style={{ position: "absolute", left: 0, color: "#7DC242", fontWeight: 700 }}>✓</span>Solicitar grúa, ambulancia, servicio médico o legal para tu familia en México.</li>
            <li style={{ fontSize: 13, color: "#4b5563", padding: "5px 0 5px 22px", position: "relative", lineHeight: 1.5, textAlign: "left" }}><span style={{ position: "absolute", left: 0, color: "#7DC242", fontWeight: 700 }}>✓</span>Administrar los datos de tus beneficiarios y su ficha médica.</li>
            <li style={{ fontSize: 13, color: "#4b5563", padding: "5px 0 5px 22px", position: "relative", lineHeight: 1.5, textAlign: "left" }}><span style={{ position: "absolute", left: 0, color: "#7DC242", fontWeight: 700 }}>✓</span>Renovar tu plan, ver tu historial de servicios y revisar tus referidos.</li>
            <li style={{ fontSize: 13, color: "#4b5563", padding: "5px 0 5px 22px", position: "relative", lineHeight: 1.5, textAlign: "left" }}><span style={{ position: "absolute", left: 0, color: "#7DC242", fontWeight: 700 }}>✓</span>Activar el módulo de Chequeo de Salud (Anura) para monitorear sus signos vitales.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
